import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Edit Board Information'
});
